import reduceReducers from './reduceReducers';
import { appReducer } from '../App';
import { contactMeReducer } from '../ContactMe';
import { questionReducer } from '../Question';
import { navigationReducer } from '../Navigation';
import { productReducer } from '../Product';
import { progressReducer } from '../Progress';
import { validationReducer } from '../Validation';
import { loginReducer, notesReducer } from '../../guide-framework/state';

const initializeReducer = ({ reducers = [], initialAppState = {} }) => {
  return reduceReducers(initialAppState, [
    appReducer,
    contactMeReducer,
    loginReducer,
    navigationReducer,
    notesReducer,
    productReducer,
    progressReducer,
    questionReducer,
    validationReducer,
    ...reducers,
  ]);
};

export default initializeReducer;
